<app-card
  [cardClasses]="cardClasses"
  [cardHeaderClasses]="cardHeaderClasses"
  cardHeaderTitle="{{ title }}"
  [header]="!titleInBody"
  [cardBodyClasses]="!titleInBody ? 'pt-0' : ''"
  [titleInBody]="titleInBody"
>
  <ng-container cardBody>
    <app-skeleton-text [count]="4" type="text-and-text" [isLoading]="loading" [fluidSize]="true">
      <ng-container *ngIf="!title && titleInBody">
        <h5 class="fw-bolder mb-7 title">
          <ng-content select="[htmlTitle]"></ng-content>
        </h5>
      </ng-container>

      <div class="row mt-7" *ngFor="let item of bodyList">
        <ng-container *ngIf="item.title; else noTitleSeparatorTpl">
          <div class="col-md-12">
            <div class="fw-bolder">
              <ng-container>
                {{ item.title }}
              </ng-container>
            </div>
          </div>
        </ng-container>

        <ng-template #noTitleSeparatorTpl>
          <div class="col-md-3 col-3">
            <label class="text-gray-700">
              {{ item.label }}
            </label>
          </div>
          <div class="col-md-9 col-9">
            <span class="text-gray-900">
              <span *ngIf="!item.title">:</span>
              <span class="{{ 'fw-' + item.valueWeight + ' ' + 'text-' + item.valueColor }}"> {{ item.value ?? '-' }}</span>
              <br />
              <span *ngIf="item.new || item.value_bottom" class="{{ item.new ? 'text-info-label fw-bold' : '' }}">
                <span>:</span>
                <span class="ms-1">{{ item.new || item.value_bottom }}</span>
              </span>
            </span>
          </div>
        </ng-template>
      </div>
    </app-skeleton-text>

    <ng-content></ng-content>
  </ng-container>
</app-card>
